import { useIntl } from 'react-intl'

export const getTeaProperties = ({
  c_caffeine,
  c_specialties,
  c_aromatisation,
  c_origin,
  c_daytime,
  c_aromaticAssociation
}: {
  c_caffeine?: boolean | null
  c_specialties?: string
  c_aromatisation?: string
  c_origin?: string[]
  c_daytime?: string[]
  c_aromaticAssociation?: string[]
}) => {
  const { formatMessage } = useIntl()
  const translations = [
    typeof c_caffeine === 'boolean' && {
      key: formatMessage({
        id: 'msp.product.properties.caffeine',
        defaultMessage: 'Caffeine'
      }),
      value: c_caffeine
        ? formatMessage({
            id: 'msp.product.properties.caffeineYes',
            defaultMessage: 'Yes'
          })
        : formatMessage({
            id: 'msp.product.properties.caffeineNo',
            defaultMessage: 'No'
          })
    },
    !!c_specialties && {
      key: formatMessage({
        id: 'msp.product.properties.specialties',
        defaultMessage: 'Specialties'
      }),
      value: c_specialties
    },
    !!c_origin && {
      key: formatMessage({
        id: 'msp.product.properties.origin',
        defaultMessage: 'Origin'
      }),
      value: c_origin
    },
    !!c_daytime && {
      key: formatMessage({
        id: 'msp.product.properties.time_of_day',
        defaultMessage: 'Time of day'
      }),
      value: c_daytime.join(', ')
    },
    !!c_aromaticAssociation && {
      key: formatMessage({
        id: 'msp.product.properties.association',
        defaultMessage: 'Association'
      }),
      value: c_aromaticAssociation.join(', ')
    }
  ].filter((elem) => typeof elem === 'object' && Object.keys(elem).length > 0)

  if (translations.length > 0 || c_aromatisation) {
    translations.splice(1, 0, {
      key: formatMessage({
        id: 'msp.product.properties.aromatisation',
        defaultMessage: 'Aromatisation'
      }),
      value: c_aromatisation || '-'
    })
  }

  return translations
}

export const getIngredientsAndAllergens = ({
  c_ingredients,
  c_allergens
}: {
  c_ingredients?: string
  c_allergens?: string
}) => {
  const { formatMessage } = useIntl()
  const translations = [
    !!c_ingredients && {
      key: formatMessage({
        id: 'msp.product.properties.ingredients',
        defaultMessage: 'Ingredients'
      }),
      value: c_ingredients.replace(/\r\n/g, '<br>')
    },
    !!c_allergens && {
      key: formatMessage({
        id: 'msp.product.properties.allergens',
        defaultMessage: 'Allergens'
      }),
      value: c_allergens
    }
  ]
  return translations.filter(
    (elem) => typeof elem === 'object' && Object.keys(elem).length > 0
  )
}
